/**
 * Cron expression enum. Taken from:
 * @see https://github.com/nestjs/schedule/blob/master/lib/enums/cron-expression.enum.ts
 */
export var CronExpressionEnum;
(function (CronExpressionEnum) {
    CronExpressionEnum["EVERY_SECOND"] = "* * * * * *";
    CronExpressionEnum["EVERY_5_SECONDS"] = "*/5 * * * * *";
    CronExpressionEnum["EVERY_10_SECONDS"] = "*/10 * * * * *";
    CronExpressionEnum["EVERY_30_SECONDS"] = "*/30 * * * * *";
    CronExpressionEnum["EVERY_MINUTE"] = "*/1 * * * *";
    CronExpressionEnum["EVERY_5_MINUTES"] = "0 */5 * * * *";
    CronExpressionEnum["EVERY_10_MINUTES"] = "0 */10 * * * *";
    CronExpressionEnum["EVERY_30_MINUTES"] = "0 */30 * * * *";
    CronExpressionEnum["EVERY_HOUR"] = "0 0-23/1 * * *";
    CronExpressionEnum["EVERY_2_HOURS"] = "0 0-23/2 * * *";
    CronExpressionEnum["EVERY_3_HOURS"] = "0 0-23/3 * * *";
    CronExpressionEnum["EVERY_4_HOURS"] = "0 0-23/4 * * *";
    CronExpressionEnum["EVERY_5_HOURS"] = "0 0-23/5 * * *";
    CronExpressionEnum["EVERY_6_HOURS"] = "0 0-23/6 * * *";
    CronExpressionEnum["EVERY_7_HOURS"] = "0 0-23/7 * * *";
    CronExpressionEnum["EVERY_8_HOURS"] = "0 0-23/8 * * *";
    CronExpressionEnum["EVERY_9_HOURS"] = "0 0-23/9 * * *";
    CronExpressionEnum["EVERY_10_HOURS"] = "0 0-23/10 * * *";
    CronExpressionEnum["EVERY_11_HOURS"] = "0 0-23/11 * * *";
    CronExpressionEnum["EVERY_12_HOURS"] = "0 0-23/12 * * *";
    CronExpressionEnum["EVERY_DAY_AT_1AM"] = "0 01 * * *";
    CronExpressionEnum["EVERY_DAY_AT_2AM"] = "0 02 * * *";
    CronExpressionEnum["EVERY_DAY_AT_3AM"] = "0 03 * * *";
    CronExpressionEnum["EVERY_DAY_AT_4AM"] = "0 04 * * *";
    CronExpressionEnum["EVERY_DAY_AT_5AM"] = "0 05 * * *";
    CronExpressionEnum["EVERY_DAY_AT_6AM"] = "0 06 * * *";
    CronExpressionEnum["EVERY_DAY_AT_7AM"] = "0 07 * * *";
    CronExpressionEnum["EVERY_DAY_AT_8AM"] = "0 08 * * *";
    CronExpressionEnum["EVERY_DAY_AT_9AM"] = "0 09 * * *";
    CronExpressionEnum["EVERY_DAY_AT_10AM"] = "0 10 * * *";
    CronExpressionEnum["EVERY_DAY_AT_11AM"] = "0 11 * * *";
    CronExpressionEnum["EVERY_DAY_AT_NOON"] = "0 12 * * *";
    CronExpressionEnum["EVERY_DAY_AT_1PM"] = "0 13 * * *";
    CronExpressionEnum["EVERY_DAY_AT_2PM"] = "0 14 * * *";
    CronExpressionEnum["EVERY_DAY_AT_3PM"] = "0 15 * * *";
    CronExpressionEnum["EVERY_DAY_AT_4PM"] = "0 16 * * *";
    CronExpressionEnum["EVERY_DAY_AT_5PM"] = "0 17 * * *";
    CronExpressionEnum["EVERY_DAY_AT_6PM"] = "0 18 * * *";
    CronExpressionEnum["EVERY_DAY_AT_7PM"] = "0 19 * * *";
    CronExpressionEnum["EVERY_DAY_AT_8PM"] = "0 20 * * *";
    CronExpressionEnum["EVERY_DAY_AT_9PM"] = "0 21 * * *";
    CronExpressionEnum["EVERY_DAY_AT_10PM"] = "0 22 * * *";
    CronExpressionEnum["EVERY_DAY_AT_11PM"] = "0 23 * * *";
    CronExpressionEnum["EVERY_DAY_AT_MIDNIGHT"] = "0 0 * * *";
    CronExpressionEnum["EVERY_WEEK"] = "0 0 * * 0";
    CronExpressionEnum["EVERY_WEEKDAY"] = "0 0 * * 1-5";
    CronExpressionEnum["EVERY_WEEKEND"] = "0 0 * * 6,0";
    CronExpressionEnum["EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT"] = "0 0 1 * *";
    CronExpressionEnum["EVERY_1ST_DAY_OF_MONTH_AT_NOON"] = "0 12 1 * *";
    CronExpressionEnum["EVERY_2ND_HOUR"] = "0 */2 * * *";
    CronExpressionEnum["EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM"] = "0 1-23/2 * * *";
    CronExpressionEnum["EVERY_2ND_MONTH"] = "0 0 1 */2 *";
    CronExpressionEnum["EVERY_QUARTER"] = "0 0 1 */3 *";
    CronExpressionEnum["EVERY_6_MONTHS"] = "0 0 1 */6 *";
    CronExpressionEnum["EVERY_YEAR"] = "0 0 1 0 *";
    CronExpressionEnum["EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM"] = "0 */30 9-17 * * *";
    CronExpressionEnum["EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM"] = "0 */30 9-18 * * *";
    CronExpressionEnum["EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM"] = "0 */30 10-19 * * *";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_1AM"] = "0 0 01 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_2AM"] = "0 0 02 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_3AM"] = "0 0 03 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_4AM"] = "0 0 04 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_5AM"] = "0 0 05 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_6AM"] = "0 0 06 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_7AM"] = "0 0 07 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_8AM"] = "0 0 08 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_9AM"] = "0 0 09 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_09_30AM"] = "0 30 09 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_10AM"] = "0 0 10 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_11AM"] = "0 0 11 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_11_30AM"] = "0 30 11 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_12PM"] = "0 0 12 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_1PM"] = "0 0 13 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_2PM"] = "0 0 14 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_3PM"] = "0 0 15 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_4PM"] = "0 0 16 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_5PM"] = "0 0 17 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_6PM"] = "0 0 18 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_7PM"] = "0 0 19 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_8PM"] = "0 0 20 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_9PM"] = "0 0 21 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_10PM"] = "0 0 22 * * 1-5";
    CronExpressionEnum["MONDAY_TO_FRIDAY_AT_11PM"] = "0 0 23 * * 1-5";
})(CronExpressionEnum || (CronExpressionEnum = {}));
//# sourceMappingURL=cron.js.map